// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Divider, Drawer, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import { BouncyChest } from "components/BouncyChest";
import PoisBountyWidgetV3 from "components/PoisBountyWidgetV3";
import { PWABanner } from "components/PWA/PWABanner";
import { RebateIcon } from "components/RebateOffer/RebateIcon";
import UserProfile from "components/UserProfile";
import { useEnvContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppSelector } from "hooks";
import { Fragment, useEffect, useMemo } from "react";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { selectPoisBountyV3State } from "redux/slices";
import { setOpen } from "redux/slices/mega-menu";
import { RootState } from "redux/store";
import { categories } from "./categories";
import { MenuLinks, StoreButtons, SubMenu } from "./lib";
import SignUpIncentiveBanner from "./lib/SignUpIncentiveBanner";
import {
	CategoryContainer,
	CategoryDescription,
	DesktopContainer,
	FirstPanel,
	MobileContainer,
	SecondPanel,
	SubMenuContainer,
	UserContainer,
	Wrapper
} from "./styles";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PushBanner } from "components/PWA/PushBanner";

export const MegaMenu = () => {
	const isOpen = useSelector((state: RootState) => state.megaMenu.isOpen);
	const dispatch = useDispatch();
	const { isFeatureFlagEnabled } = useEnvContext();
	const toggleDrawer = (state: boolean) => dispatch(setOpen(state));
	const { trackers } = useAppSelector(selectPoisBountyV3State);
	const isPortrait = useMediaQuery("(max-width: 819px)");
	const isClub = useMemo(
		() => trackers?.eventType === "club",
		[trackers?.eventType]
	);

	useEffect(() => {
		//Effect to prevent removal of Keepmounted on Drawer
		const paperContainer = document.querySelector("#MenuPaper");
		if (paperContainer) {
			paperContainer.scrollTop = 0;
		}
	}, [isOpen]);

	useEffect(() => {
		//Effect to close the drawer when path changes
		const handleBrowserButton = () => {
			if (isOpen) {
				toggleDrawer(false);
			}
		};
		window.addEventListener("popstate", handleBrowserButton);
		return () => {
			window.removeEventListener("popstate", handleBrowserButton);
		};
	}, [isOpen]);

	return (
		<Drawer
			anchor="top"
			open={isOpen}
			onClose={() => toggleDrawer(false)}
			BackdropProps={{ style: { opacity: 0 } }}
			ModalProps={{
				keepMounted: true
			}}
			PaperProps={{
				id: "MenuPaper",
				sx: {
					//top: "65px",
					//maxHeight: "98vh"
				}
			}}
		>
			{isPortrait ? (
				<MobileContainer>
					<SignUpIncentiveBanner />
					{isMobile && <PWABanner from="mega-menu" />}
					{isMobile && <PushBanner from="mega-menu" />}
					{categories?.map((category) => (
						<SubMenu categoryId={category.id} key={category.id} />
					))}
					<UserProfile />
					<StoreButtons />
					<MenuLinks />

					<div
						style={{
							position: "fixed",
							margin: "5px",
							right: "0px",
							bottom: "8%",
							justifyItems: "right"
						}}
					>
						{isFeatureFlagEnabled(FeaturesFlags.BOUNCY_CHEST) && (
							<BouncyChest from="mega-menu" />
						)}
						{/* {isFeatureFlagEnabled(FeaturesFlags.REBATE) && (
							<RebateIcon from="mega-menu" />
						)} */}
						<RebateIcon from="mega-menu" />
					</div>

					{
						//TODO Data should be preloaded using a hook to prevent rendering the component in portrait mode
						isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2) && (
							<PoisBountyWidgetV3
								style={{ margin: "0 auto", marginTop: "40px" }}
								isPortrait={false}
								isClub={isClub}
							/>
						)
					}
				</MobileContainer>
			) : (
				<DesktopContainer>
					<FirstPanel>
						<Wrapper>
							{categories?.map((category) => (
								<CategoryContainer key={category.id}>
									{category.id !== 1 && (
										<Fragment>
											<CategoryDescription>
												{category.description}
											</CategoryDescription>
											<Divider sx={{ padding: "5px" }}></Divider>
										</Fragment>
									)}
									<SubMenuContainer>
										<SubMenu categoryId={category.id} />
									</SubMenuContainer>
								</CategoryContainer>
							))}
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									flexDirection: "column",
									alignItems: "center"
								}}
							>
								<SignUpIncentiveBanner />
								{isMobile && <PWABanner from="mega-menu" />}
								{isMobile && <PushBanner from="mega-menu" />}
							</div>

							<StoreButtons />
							<MenuLinks />
						</Wrapper>
					</FirstPanel>
					<SecondPanel>
						<Box sx={{ width: "100%" }}>
							<Box sx={{ overflowX: "auto" }}>
								{isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2) && (
									<PoisBountyWidgetV3
										style={{ margin: "0 auto", marginTop: "40px" }}
										isPortrait={false}
										isClub={isClub}
									/>
								)}
							</Box>
						</Box>
						<UserContainer>
							<div
								style={{
									width: "100%",
									justifyContent: "right",
									display: "flex",
									position: "relative"
								}}
							>
								{isFeatureFlagEnabled(FeaturesFlags.BOUNCY_CHEST) && (
									<BouncyChest from="mega-menu" />
								)}
								{/* {isFeatureFlagEnabled(FeaturesFlags.REBATE) && (
									<RebateIcon from="mega-menu" />
								)} */}
								<RebateIcon from="mega-menu" />
							</div>
							<UserProfile />
						</UserContainer>
					</SecondPanel>
				</DesktopContainer>
			)}
		</Drawer>
	);
};
